/**
 * Count-session liveness helpers.
 *
 * Historical count rows deliberately keep their inventory_item_id after a
 * catalog item is archived. Forward-looking rows are different: a template,
 * a new run copied from a template, and an untouched draft must never keep
 * offering an archived item as something to count. These helpers keep that
 * distinction explicit and preserve rows whose inventory record could not be
 * loaded instead of silently dropping data on an incomplete lookup.
 */

export function isLiveInventoryItem(item) {
  if (!item) return false;
  return item.is_active !== false && !item.deleted_at;
}

export function shouldHideArchivedCountItems(session) {
  if (!session) return false;
  return session.is_template === true || session.status === 'draft';
}

export function filterCountItemsToLiveInventory(countItems, inventoryItems, {
  preserveUnknown = true,
} = {}) {
  const stateById = new Map(
    (inventoryItems || [])
      .filter((item) => item?.id !== null && item?.id !== undefined)
      .map((item) => [String(item.id), item]),
  );

  return (countItems || []).filter((row) => {
    const itemId = row?.inventory_item_id ?? row?.item_snapshot?.id ?? null;
    if (itemId === null || itemId === undefined) return preserveUnknown;
    const inventory = stateById.get(String(itemId));
    if (!inventory) return preserveUnknown;
    return isLiveInventoryItem(inventory);
  });
}
